import React, { Component } from "react";
import { formatMoney, formatMoneyFlexCurrency } from "../../../lib/format-money";
import get from "lodash/get";
import HighlightBox from "../../lib/highlight-box";
import { Row, Col } from "react-bootstrap";
import Spinner from "../../lib/spinner";

export default class BalanceIndicator extends Component {
  componentDidMount() {
    this.fetchBalanceIfConnected(get(this.props, "user.isStripeConnected"));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (get(this.props, "user.isStripeConnected") !== get(nextProps, "user.isStripeConnected")) {
      this.fetchBalanceIfConnected(get(nextProps, "user.isStripeConnected"));
    }
  }

  fetchBalanceIfConnected = isConnected => {
    if (isConnected) {
      this.props.getStripeBalance();
    }
  };

  tipsTotal = () => {
    if (!this.props.transactions || !this.props.transactions.length) {
      return 0;
    }

    return this.props.transactions.reduce((agg, value) => {
      return agg + value.amount;
    }, 0);
  };

  render() {
    return (
      <div className="balance-indicator">
        <Spinner isLoading={this.props.isLoading} />
        <Row>
          <Col xs={12} md={4}>
            <HighlightBox title="All Time Earnings" value={formatMoney(this.tipsTotal() / 1000)} />
          </Col>

          <Col xs={12} md={4}>
            <HighlightBox
              title="Pending Balance"
              value={get(this.props, "stripeBalancePending", []).map(({ amount, currency }) => (
                <div key={currency}>{formatMoneyFlexCurrency({ amount, currency })}</div>
              ))}
              scalableHeight
              infoText={
                "pending amount in your stripe account waiting to be cleared.</br> pending balance should become available soon."
              }
            />
          </Col>
          <Col xs={12} md={4}>
            <HighlightBox
              title="Current Balance"
              scalableHeight
              value={get(this.props, "stripeBalance", []).map(({ amount, currency }) => (
                <div key={currency}>{formatMoneyFlexCurrency({ amount, currency })}</div>
              ))}
              infoText={
                "balance in your stripe account ready to be transferred</br> to your bank. click ‘transfer to bank’ to withdraw."
              }
            />
          </Col>
        </Row>
      </div>
    );
  }
}
